import React, { useEffect } from 'react'

function AboutUs(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page about-us-page">
        <section
          className="hero-banner inner-banner center-bg"
          style={{ backgroundImage: `url('images/aboutus-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="partner-banner-content">
                  <h1>About Us</h1>
                  <text>
                    Learn about what drives us forward and
                    <br /> what we are trying to acomplish.
                  </text>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="aboutus-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 text-center">
                <div className="about-content">
                  <h2>About RoadJockey</h2>
                  <text>
                    <p>
                      RoadJockey is a technology company that bonds the people
                      of Jamaica with their favorite foods. We empower local
                      businesses by creating a new platform for them to reach
                      out to customers from all over the island through the
                      convenience of door-to-door delivery.
                    </p>

                    <p>
                      <br />
                      RoadJockey began as an idea from famous Race Horse Jockey
                      Rajiv Maragh and his cousin, both Jamaican-born. Their
                      time in the states presented an excellent opportunity of
                      creating a service designed just for the Caribbean. Their
                      local knowledge and understanding of neighborly culture
                      fueled their desire to offer a custom-made experience for
                      the friends and family back home in Jamaica.
                    </p>
                    <p>
                      <br />
                      What started as a single idea has grown into a wonderful
                      business. Both of our founders are proud to offer the same
                      quality service and convenience of food delivery to
                      everyone within the area. RoadJockey will bring new life
                      to the economy by elevating local business and creating
                      new earning income for Roadies.
                    </p>
                    <p>
                      <br />
                      Thank you for learning more about the RoadJockey app. If
                      you would like to get your next meal delivered straight to
                      your home, office, or event, download our app and sign up
                      today. You&apos;ll experience the best food Jamaica has to
                      offer.
                    </p>
                  </text>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="benefit-sec yellow-sec pb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="benfit-figure">
                  <img
                    src="images/about_us/about.jpg"
                    width="610"
                    height="541.72"
                    alt="about-page-img"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="benefit-content">
                  <h2 className="pb-30">Our Mission</h2>
                  <p>
                    To deliver both quality food and service from our food
                    partners to customers all over our region. Our vision is to
                    grow into the best food delivery service in all the
                    Caribbean.
                  </p>
                  <p>
                    {' '}
                    <h2 className="pb-30">Our Philosophy</h2>
                  </p>
                  <p>
                    We value fast service and strong customer relationships.
                    Each of our food partners expects us to act as ambassadors
                    for their brand with every delivery. We ensure our Roadies
                    are qualified and prepared while still empowering them to
                    grow their earning potential. Our goal is to provide a
                    business center for facilitating these transactions and help
                    grow the economy of the entire Caribbean one successful
                    delivery at a time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default AboutUs
